const state = {
  jobs: [],
  totalJob: 0,
  jobsCategory: [],
  listJobsCity: [],
  listJobNeighborhood: [],
  jobProfileVideo: {},
  jobsAlert: [],
  totalJobsAlert: 0,
  listJobsPending: [],
  jobAlertSettings: [],
  listInterestedTalents: [],
  totalInterestedTalent: 0,
  listJoinedTalents: [],
  totalJoinedTalent: 0,
  listWaitForConfirmationTalents: [],
  totalWaitForConfirmationTalent: 0,
  listOtherTopRatedTalents: [],
  totalOtherTopRatedTalent: 0
}

export default state
